import * as t from "io-ts"

export const DeviceSearchResult = t.type({
    displayValue: t.string,
    deviceRef: t.string,
    deviceModelNo: t.string,
    deviceManufacturer: t.string,
    deviceSize: t.number,
    deviceSizeName: t.string,
    deviceSizeUnit: t.string,
    devicePhases: t.string,
})

export const DeviceSearchResults = t.array(DeviceSearchResult)

export type IDeviceSearchResult = t.TypeOf<typeof DeviceSearchResult>
